import React from "react";
import { MobergButton, MobergButtonShape, MobergButtonVariant, MobergTheme } from "../../../Moberg";
import { RemoteMonitoringModalFooter } from "../../../Constants/StyledComponents";
import { MdArrowBack } from "react-icons/md";

const ModalFooter = ({ 
    showBackButton = false,
    showNextButton = false,
    showToggleButton = false,
    showCustomLeftButton = false,
    customLeftButtonText = "",
    customLeftButtonIcon = null,
    onBack,
    onNext,
    onToggle,
    onCustomLeftButton,
    isNextDisabled = false,
    isToggleDisabled = false,
    nextButtonText = "Next",
    toggleButtonText = "Toggle",
    nextButtonTheme = MobergTheme.BLUE
}) => {
    if (!showBackButton && !showNextButton && !showToggleButton && !showCustomLeftButton) {
        return null;
    }

    return (
        <RemoteMonitoringModalFooter>
            {showBackButton && (
                <MobergButton
                    variant={MobergButtonVariant.OUTLINE}
                    theme={MobergTheme.BLUE}
                    shape={MobergButtonShape.RECTANGLE}
                    onClick={onBack}
                    style={{ width: "100px", height: "40px", fontSize: "15px" }}
                >
                    Back
                </MobergButton>
            )}
            {showCustomLeftButton && (
                <MobergButton
                    variant={MobergButtonVariant.OUTLINE}
                    theme={MobergTheme.BLUE}
                    shape={MobergButtonShape.RECTANGLE}
                    onClick={onCustomLeftButton}
                    style={{ minWidth: "120px", height: "40px", fontSize: "15px" }}
                >
                    {customLeftButtonIcon}
                    {customLeftButtonText}
                </MobergButton>
            )}
            <div style={{ display: "flex", gap: "12px", marginLeft: "auto" }}>
                {showToggleButton && (
                    <MobergButton
                        variant={MobergButtonVariant.OUTLINE}
                        theme={MobergTheme.BLUE}
                        shape={MobergButtonShape.RECTANGLE}
                        onClick={onToggle}
                        disabled={isToggleDisabled}
                        style={{ width: "140px", height: "40px", fontSize: "15px" }}
                    >
                        {toggleButtonText}
                    </MobergButton>
                )}
                {showNextButton && (
                    <MobergButton
                        variant={MobergButtonVariant.FILLED}
                        theme={nextButtonTheme}
                        shape={MobergButtonShape.RECTANGLE}
                        onClick={onNext}
                        disabled={isNextDisabled}
                        style={{ width: "140px", height: "40px", fontSize: "15px" }}
                    >
                        {nextButtonText}
                    </MobergButton>
                )}
            </div>
        </RemoteMonitoringModalFooter>
    );
};

export default ModalFooter;

